module.exports = __webpack_public_path__ + "img/9.773974f.png";